module.exports = __webpack_public_path__ + "img/plus-square-regular.1cf496b5.svg";